import React, { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import Logo from "./Logo";
import { Button } from "./ui/button";
import { company } from "../mock";

const links = [
  { label: "Home", href: "#home" },
  { label: "Services", href: "#services" },
  { label: "Why Us", href: "#why" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact", href: "#contact" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#071a2f]/95 backdrop-blur-md shadow-lg shadow-black/30 py-2"
          : "bg-transparent py-4"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between">
        <a href="#home" className="shrink-0">
          <Logo compact />
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="font-cond uppercase text-sm tracking-widest text-slate-200 hover:text-[#35c6f4] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:block">
          <a href={company.phoneHref}>
            <Button className="bg-[#35c6f4] hover:bg-[#0a6bb0] text-[#071a2f] hover:text-white font-cond uppercase tracking-wider rounded-full px-5 transition-colors">
              <Phone className="h-4 w-4 mr-2" />
              {company.phone}
            </Button>
          </a>
        </div>

        <button
          className="md:hidden text-white p-2"
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#071a2f]/98 backdrop-blur border-t border-white/10 px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="font-cond uppercase tracking-widest text-slate-200 hover:text-[#35c6f4]"
            >
              {l.label}
            </a>
          ))}
          <a href={company.phoneHref} onClick={() => setOpen(false)}>
            <Button className="w-full bg-[#35c6f4] hover:bg-[#0a6bb0] text-[#071a2f] hover:text-white font-cond uppercase tracking-wider rounded-full">
              <Phone className="h-4 w-4 mr-2" />
              {company.phone}
            </Button>
          </a>
        </div>
      )}
    </header>
  );
};

export default Navbar;
